var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoClassificacaoFiscal01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lista-de-verificacao",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_907",
    d: "M1,7.4h4.7c0.3,0,0.6-0.3,0.6-0.6V5.1H5.1v1.2H1.6V2.7h1.8V1.6H1c-0.3,0-0.6,0.3-0.6,0.6v4.7 C0.4,7.1,0.7,7.4,1,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_908",
    d: "M3.3,4.2L2.6,3.5L1.7,4.3l1.2,1.2c0.2,0.2,0.6,0.2,0.8,0c0,0,0,0,0,0L7.2,2L6.4,1.2L3.3,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_909",
    d: "M5.1,13.8H1.6v-3.5h1.8V9.2H1c-0.3,0-0.6,0.3-0.6,0.6v4.7C0.4,14.7,0.7,15,1,15h4.7 c0.3,0,0.6-0.3,0.6-0.6v-1.8H5.1V13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_910",
    d: "M3.3,11.8l-0.8-0.8l-0.8,0.8l1.2,1.2c0.2,0.2,0.6,0.2,0.8,0c0,0,0,0,0,0l3.5-3.5L6.4,8.7L3.3,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_911",
    d: "M5.7,16.8H1c-0.3,0-0.6,0.3-0.6,0.6V22c0,0.3,0.3,0.6,0.6,0.6h4.7c0.3,0,0.6-0.3,0.6-0.6v-4.7 C6.2,17,6,16.8,5.7,16.8z M5.1,21.4H1.6v-3.5h3.5V21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_912",
    d: "M5.7,24.3H1c-0.3,0-0.6,0.3-0.6,0.6v4.7c0,0.3,0.3,0.6,0.6,0.6h4.7c0.3,0,0.6-0.3,0.6-0.6v-4.7 C6.2,24.6,6,24.3,5.7,24.3z M5.1,29H1.6v-3.5h3.5V29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_913",
    d: "M30-0.6c-0.2-0.2-0.6-0.2-0.8,0c0,0,0,0,0,0l-3.7,3.7l-5.4-5.4c-0.1-0.1-0.3-0.2-0.4-0.2H-1.9 c-0.3,0-0.6,0.3-0.6,0.6l0,0v33.9c0,0.3,0.3,0.6,0.6,0.6h27.4c0.3,0,0.6-0.3,0.6-0.6V8.8l6.2-6.3c0.2-0.2,0.2-0.6,0-0.8 c0,0,0,0,0,0L30-0.6z M24.9,31.4H-1.3V-1.4h20.8l4.7,4.7h-3.8V0.4h-1.2v3.5c0,0.3,0.3,0.6,0.6,0.6h4.4L10.5,18.1 c-0.1,0.1-0.1,0.1-0.1,0.2l-1.2,3.5c-0.1,0.3,0.1,0.6,0.4,0.7c0.1,0,0.2,0,0.4,0l3.5-1.2c0.1,0,0.2-0.1,0.2-0.1L24.9,10L24.9,31.4z  M11.2,19.6l1,1l-1.5,0.5L11.2,19.6z M13.3,20l-1.5-1.5L29.6,0.6l1.5,1.5L13.3,20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_914",
    d: "M22.6,29h1.2v1.2h-1.2V29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_915",
    d: "M20.3,29h1.2v1.2h-1.2V29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_916",
    d: "M17.9,29h1.2v1.2h-1.2V29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClassificacaoFiscal01);
export default __webpack_public_path__ + "static/media/ico-classificacao-fiscal-01.82ecc2fcdb16e9a091cb62fe8f0b7e90.svg";
export { ForwardRef as ReactComponent };